// Help article for Evidence Files (ENG-2129): the Evidence Files section of
// the Evidence Items page. GitBook builds the anchor from the heading text, so
// renaming that heading breaks this link. Every Learn more link in the
// evidence item Files tab and the ENG-2133 messaging points here, so it
// changes in one place.
export const EVIDENCE_FILES_HELP_URL =
  "https://docs.monolithforensics.com/monolith/using-monolith/evidence-management/evidence-items#evidence-files";

// The Files tab banner's dismissal key. Bump the version when the copy changes
// enough that users who closed it should see it again.
export const EVIDENCE_FILES_BANNER_ID = "evidence-files-tab:v1";

/** The evidence item's folder in Case Files (the same rows as its Files tab). */
export const caseFilesFolderPath = (case_id: number, folder_uuid: string) =>
  `/cases/${case_id}/documents/folders/${folder_uuid}`;

// The Case Files banner inside an evidence item's folder (ENG-2133). Its own
// key, so dismissing it doesn't hide the Files tab banner.
export const EVIDENCE_ITEM_FOLDER_BANNER_ID = "evidence-item-folder:v1";

// The Case Files banner at the Evidence Files root (ENG-2251). Its own key, so
// closing it doesn't hide the item folder banners. The (?) on the Evidence
// Files breadcrumb keeps the same copy reachable once it's closed.
export const EVIDENCE_FILES_ROOT_BANNER_ID = "evidence-files-root:v1";
